// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___ecfd561bf8f90f14f35","cls2":"FeedbackModal-cls2___cf6aa911b3f458ac589 FeedbackModal-cls1___ecfd561bf8f90f14f35"};